import IconChevron from '../icons/chevron_down.svg?component';
import DatePicker from './datepicker.js';

export default {
    mixins: [ DatePicker ],
    props: {
        /**
         * Заголовок поля
         */
        label: {
            type: String,
            required: true,
        },
        /**
         * Запись, когда ничего не выбрано
         */
        emptyValue: {
            type: String,
            default: 'Не выбрано',
        },
    },
    components: {
        IconChevron,
    },
    computed: {},
    methods: {
        toggleOpen() {
            this.opened = !this.opened;
        },
    },
};
